const PREFIX = 'EXPERIMENTS';

export const Actions = {
  SET_USER_IDENTIFIER: `${PREFIX}/SET_USER_IDENTIFIER`,
  DEFINE_EXPERIMENT: `${PREFIX}/DEFINE_EXPERIMENT`,
  SELECT_VARIANT: `${PREFIX}/SELECT_VARIANT`,
  PLAY_EXPERIMENT: `${PREFIX}/PLAY_EXPERIMENT`,
};

export const STATE_NAME = 'experiments';
export const USER_IDENTIFIER_COOKIE_NAME = 'ha_anonymous_id';
